import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import {
  CurrencyUnit,
  IJobCategoryBase,
  ILocationBase,
  ISkillBase,
  JobCategoryBase,
  JobTypeOfPosition,
  JobWorkExperience,
  JobWorkingForm,
  TokenGrant,
} from '@/types'
import { KeywordSearchGroupPrimaryForm } from '@/components/organisms/KeywordSearchGroupPrimaryForm'
import { FormItem } from '@/components/atoms/FormItem'
import { TypeOfPositionCheckboxField } from '@/components/molecules/TypeOfPositionCheckboxField'
import { WorkingFormCheckboxField } from '@/components/molecules/WorkingFormCheckboxField'
import { JobCategoriesField } from '@/components/atoms/JobCategoriesField'
import { TokenGrantField } from '@/components/molecules/TokenGrantField'

export type JobsValues = {
  keyword: string
  unit: CurrencyUnit
  maxSalary: string
  minSalary: string
  token: TokenGrant[]
  typeOfPosition: JobTypeOfPosition[]
  workExperience: JobWorkExperience
  workingForm: JobWorkingForm[]
  jobCategories: IJobCategoryBase[]
  skills: ISkillBase[]
  locations: ILocationBase[]
}

type Props = {
  values: JobsValues
  setFieldValue: (field: string, value: string | JobCategoryBase[], shouldValidate?: boolean) => void
}

export const JobsPrimaryForm: FC<Props> = ({ values, setFieldValue }) => {
  const { t } = useTranslation(['jobs', 'p', 'search'])
  return (
    <KeywordSearchGroupPrimaryForm title={t('検索条件')}>
      <FormItem label={t('p:募集形態')}>
        <TypeOfPositionCheckboxField />
      </FormItem>
      <FormItem label={t('リモートの可否')}>
        <WorkingFormCheckboxField />
      </FormItem>
      <FormItem label={t('職種')}>
        <JobCategoriesField
          selectedJobCategories={values?.jobCategories}
          setFieldValue={(jobCategories) => setFieldValue('jobCategories', jobCategories)}
          placeholder={t('search:職種を検索')}
        />
      </FormItem>
      <FormItem label={t('トークンの有無')}>
        <TokenGrantField />
      </FormItem>
    </KeywordSearchGroupPrimaryForm>
  )
}
